import { Injectable, inject } from '@angular/core';
import { Logger } from '../generic/logging/default-log.service';
import { BaseService } from '../generic/service/base.service';
import { HttpClient } from '../generic/service/http.service';
import { ConfigurationHelper } from '../generic/helper/configuration.helper';
import { RedirectService } from '../generic/service/redirect.service';

@Injectable()
export class LanguageService extends BaseService {
    private http = inject(HttpClient);
    private redirectService = inject(RedirectService);

    constructor() {
        const logger = inject(Logger);

        super(logger);
    }

    /**
     * change language and notify listeners.
     *
     * @param code
     */
    changeLanguage(code: string, isoLang: string) {
        const url = ConfigurationHelper.getWebshopUrl(
            '/public/rest/language/set',
        );

        this.http
            .post(url, JSON.stringify({ preferredLanguage: code }))
            .subscribe(
                () => {
                    window.location.href =
                        this.redirectService.replaceLanguageForGivenUrl(
                            window.location,
                            isoLang,
                        );
                },
                error => this.logger.error('Failed to change language', error),
            );
    }

    /**
     * Get all available languages for the user,
     * which are stored in a JS var on the window object.
     *
     * @returns {string[]}
     */
    getLanguages(): string[] {
        return (<any>window).availableLanguages;
    }
}
